<div class="actions">
    <button
        class="action-button"
        (click)="toggleFavorite()"
        aria-label="Agregar a favoritos"
    >
        <mat-icon>favorite_border</mat-icon>
    </button>

    <button
        class="action-button"
        (click)="shareProperty()"
        aria-label="Compartir propiedad"
    >
        <mat-icon>share</mat-icon>
    </button>
</div>
